module.exports = __webpack_public_path__ + "media/new-notification-7-210334.474a2f07.mp3";